import DateIntervalPicker from '@/components/DateIntervalPicker'

export default {
  components: {
    DateIntervalPicker
  },
  data () {
    return {
      interval: [
        this.$route.query.from || null,
        this.$route.query.to || null
      ]
    }
  },
  computed: {
    params () {
      return this.$route.query
    }
  },
  watch: {
    interval () {
      this.$router.replace({
        ...this.$route,
        query: {
          ...this.$route.query,
          from: this.interval[0],
          to: this.interval[1]
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/withInterval.js